import { useApi } from "@api/ApiProvider";
import { useMutation } from "@tanstack/react-query";
import { loadOfficeActionApi } from "./officeAction.api";
import type { LoadOfficeActionParams, LoadOfficeActionResult } from "./officeAction.types";

export const useLoadOfficeAction = () => {
  const { api } = useApi();

  return useMutation<LoadOfficeActionResult, unknown, LoadOfficeActionParams>({
    mutationFn: (params) => loadOfficeActionApi(api, params),
  });
};
